package com.tixforgigs.common.ui.components.mandarin

import com.github.ajalt.colormath.calculate.wcagContrastRatio
import com.github.ajalt.colormath.model.RGB
import com.tixforgigs.apax.models.ColorVariable
import com.tixforgigs.apax.models.MandarinTokenVar
import com.tixforgigs.common.core.annotations.MissingTaramiIconKey
import com.tixforgigs.common.core.annotations.MissingTaramiMessageKey
import com.tixforgigs.common.core.extensions.format
import com.tixforgigs.common.core.util.IdHelper.generateRandomId
import io.kvision.core.Container
import io.kvision.core.onInput
import io.kvision.html.InputType
import io.kvision.html.input
import io.kvision.html.label
import io.kvision.html.span
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.icon.icon
import io.kvision.panel.hPanel
import io.kvision.panel.simplePanel
import io.kvision.state.bind
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.updateAndGet

@OptIn(ExperimentalMaterialApi::class)
fun Container.mandarinColorInput(
  listState: StateFlow<List<ColorVariable>>,
  item: ColorVariable,
  onUpdate: (ColorVariable) -> Unit = {},
) {
  val itemState = MutableStateFlow(item)
  val inputId = generateRandomId(length = 12, numbersAllowed = false)

  simplePanel(className = "xm-color-chooser").bind(itemState) { item ->
    simplePanel(className = "xm-color-input") {
      input {
        id = inputId
        name = item.variable.name
        type = InputType.COLOR
        value = item.color

        onInput { event ->
          val input = event.target.asDynamic().value as String?
          itemState.updateAndGet { item.copy(color = input.orEmpty()) }.also { onUpdate(it) }
        }
      }
    }
    label(forId = inputId) { +item.variable.name }

    listState.value.firstOrNull {
      when (item.variable) {
        MandarinTokenVar.COLOR_FOREGROUND_BASE -> it.variable == MandarinTokenVar.COLOR_BACKGROUND_BASE
        //TODO define more var relations
        else -> false
      }
    }?.let { itemToCompare ->
      val contrast = RGB(item.color).wcagContrastRatio(RGB(itemToCompare.color))
      if (contrast < 3) {
        hPanel(spacing = 8) {
          @MissingTaramiIconKey
          icon("warning")
          @MissingTaramiMessageKey
          span { +"Kontrast (${contrast.format(2)}) sehr niedrig gegenüber ${itemToCompare.variable.name}" }
        }
      }
    }
  }
}